import { Middleware } from 'redux'

import { createSideEffect } from '../../../lib/redux/createSideEffectMiddleware'
import { Action } from '../../actions'
import { ConsentBannerAction } from '../../constants'
import { CONSENTED, IState } from '../../state'

function handleHideConsentBanner (): void {
  if (localStorage) {
    try {
      localStorage.setItem(CONSENTED, 'true')
    } catch (e) {
      /* left blank */
    }
  }
}

// tslint:disable-next-line:export-name
export function createConsentBannerSideEffect(): Middleware {
  return createSideEffect<IState>(() => ({
    handle: (action: Action) => {
      switch (action.type) {
        case ConsentBannerAction.HIDE_CONSENT_BANNER:
          handleHideConsentBanner()
          break
        default:
          break
      }
    },
  }))
}
